export const messages = {
  en: {
    allocationStorehouseAuditOrders: {
      title: 'Pending Orders',
      back: 'Back',
      refresh: 'Refresh',
      scheduleNo: 'Schedule No',
      allocationCount: 'Allocation Count',
      applicant: 'Applicant',
      status: 'Status',
      time: 'Time',
      operation: 'Operation',
      view: 'View',
      edit: 'Edit',
      allocation: 'Allocation',
      approve: 'Approve'
    }
  },
  zh: {
    allocationStorehouseAuditOrders: {
      title: '待办单',
      back: '返回',
      refresh: '刷新',
      scheduleNo: '调度编号',
      allocationCount: '调拨数量',
      applicant: '申请人',
      status: '状态',
      time: '时间',
      operation: '操作',
      view: '查看',
      edit: '修改',
      allocation: '调拨',
      approve: '审批'
    }
  }
}